import { useContext } from "react";
import { useNavigate } from "react-router";
import myContext from "../../../Context/myContext";

const ProductSection = () => {
    const navigate = useNavigate();
    const context = useContext(myContext);
    const { getAllProduct } = context;

    return (
        <section className="section bg-light border-top">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 mb-4 text-center mt-2">
                        <h3 className="main-heading">Our Products</h3>
                        <div className="underline mx-auto"></div>
                    </div>
                    {getAllProduct.slice(0, 3).map((item, index) => {
                        const { id, title, productImageUrl, price } = item;
                        return (
                            <div key={index} className="col-md-4 mb-4">
                                <div className="card shadow-lg">
                                    <img
                                      onClick={() => navigate(`/productinfo/${id}`)}
                                        src={productImageUrl}
                                        alt={title}
                                        style={{
                                            height: '300px', // Fixed height
                                            backgroundColor: '#cce5ff', // Blue background
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            padding: '10px', // Add padding for better visibility
                                            objectFit:'contain'
                                        }}
                                        className="card-img-top"
                                    />
                                    <div className="card-body text-center">
                                        <h5 className="card-title">{title}</h5>
                                        <p className="card-text mb-3">{price}</p>
                                        <button
                                            className="btn btn-outline-primary d-block mx-auto"
                                            onClick={() => navigate(`/productinfo/${id}`)}
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default ProductSection;
